import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Heading, Paragraph } from '@digdir/designsystemet-react';
import { PersonGroupIcon } from '@navikt/aksel-icons';
import { useGetTeamsQuery } from '../../hooks';
import { Spinner } from '../../components/Spinner';
import { TeamsList } from '../../components/TeamsList/TeamsList.tsx';
import { Routes } from '../../enums/Routes';
import { EmptyState } from '../../components/EmptyState';
import classes from './Teams.module.css';

export const Teams = () => {
  const { t } = useTranslation();
  const { data: teams, error } = useGetTeamsQuery();
  const navigate = useNavigate();

  if (error) {
    return <p>Error: {JSON.stringify(error)}</p>;
  }

  if (!teams) {
    return (
      <>
        <Spinner label={t('teams.loading.spinner')} />
        <p>{t('teams.loading.message')}</p>
      </>
    );
  }

  return (
    <div className={classes.page}>
      <div aria-hidden="true" className={classes.backdrop} />
      <div className={classes.content}>
        {teams.length === 0 ? (
          <EmptyState
            icon={<PersonGroupIcon aria-hidden fontSize="48px" />}
            title={t('teams.emptyState.title')}
            description={t('teams.emptyState.description')}
            actionLabel={t('teams.createTeam')}
            onAction={() => navigate(Routes.CreateTeam)}
          />
        ) : (
          <>
            <header className={classes.header}>
              <div className={classes.heading}>
                <span className={classes.eyebrow}>{t('teams.page.eyebrow')}</span>
                <Heading level={1} data-size="xl">
                  {t('teams.pageTitle')}
                </Heading>
                <Paragraph className={classes.summary}>
                  {t('teams.page.teamCount', { count: teams.length })}
                </Paragraph>
              </div>
              <Button asChild>
                <Link to={Routes.CreateTeam}>{t('teams.createTeam')}</Link>
              </Button>
            </header>
            <TeamsList items={teams} />
          </>
        )}
      </div>
    </div>
  );
};
